<template>
  <div style="position: relative;">
    <Breadcrumb origin-name="Communities" origin-path="/communities" :current-name="community.name" />
    <h3>Moderatorenanfragen bearbeiten</h3>
    <List :columns="columns" :values="pendingRoleRequests.filter(e => !e.hide)">
      <template #column_name="{data}">{{ data.firstName }} {{ data.lastName }}</template>
      <template #column_createdAt="{data}">{{ data.createdAt | dateFormat }}</template>
      <template #column_action="{data}">
        <div class="d-flex justify-content-center">
          <img @click.prevent="approveRequest(data.id)" src="../../assets/icons/Check-circle.svg" />
          <img @click.prevent="requestToDelete = data" src="../../assets/icons/remove.svg" />
        </div>
      </template>
    </List>
    <p>Moderatoren fordern ihren Zugang über die Juniti App an.</p>
    <Dialog :visible="requestToDelete"
            title="Moderator entfernen?"
            ok-button-text="Ja, entfernen!"
            @cancel="requestToDelete = undefined"
            @ok="removeRequest"
            :message="`Wollen Sie die Moderatorenanfrage wirklich entfernen?`">
    </Dialog>
    <div class="loading-spinner-overlay" v-if="isLoading">
      <div class="loading-spinner" />
    </div>
  </div>
</template>

<script>
import {communicator} from "@/util/communicator.js";
import {broadcast} from "@/util/eventHandler.js";
import List from "@/components/partial/List.vue";
import Breadcrumb from "@/components/partial/Breadcrumb.vue";
import Dialog from "@/components/partial/Dialog.vue";

export default {
  components: {Dialog, Breadcrumb, List},
  data() {
    return {
      isLoading: false,
      pendingRoleRequests: [],
      community: {},
      requestToDelete: undefined,
      columns: [
        { name: "Name", key: "name" },
        { name: "E-Mail Adresse", key: "email" },
        { name: "Aktion", key: "action", styles: { width: "75px" } }
      ]
    };
  },
  created() {
    if(this.$route.params.id) this.community = this.$store.state.communities.find(e => String(e.id) === this.$route.params.id);
    this.fetchPendingRoleRequests();
  },
  methods: {
    async fetchPendingRoleRequests() {
      try {
        const response = await communicator.get("/pending-role-requests/backoffice/" + this.$route.params.id);
        console.log("[Access Requests] Response: ", response.data.pendingRoleRequests);
        response.data.pendingRoleRequests.sort((a, b) => b.id - a.id);
        this.pendingRoleRequests = response.data.pendingRoleRequests.map(roleRequest => {
          if (roleRequest.requestedRole !== "moderator") {
            roleRequest.hide = true;
            return roleRequest;
          }
          return roleRequest;
        });
      } catch(e) {
        broadcast("error", e.response.data);
      }
    },

    async approveRequest(id) {
      if(this.isLoading) return;
      this.isLoading = true;
      try {
        const response = await communicator.post(`/pending-role-requests/${id}/approve`);
        console.log("Approved: ", response);
        this.fetchPendingRoleRequests();
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.isLoading = false;
    },

    async removeRequest() {
      if(this.isLoading) return;
      this.isLoading = true;
      try {
        const response = await communicator.delete(`/pending-role-requests/moderator/${this.requestToDelete.id}`);
        console.log("Removed: ", response);
        this.requestToDelete = undefined;
        this.fetchPendingRoleRequests();
      } catch(e) {
        broadcast("error", e.response.data);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);

  }
}

.d-flex {
  gap: 5px;

  > img:hover {
    cursor: pointer;
  }
}

.loading-spinner-overlay {
  position: absolute;
  width: 100%;
  top: 35px;
  backdrop-filter: blur(4px);
  .loading-spinner {
    width: 3rem;
    height: 3rem;
    margin: 5rem auto;
    border: solid 3px rgba(0, 0, 0, 0.1);
    border-bottom-color: #5B41E1;
    animation-name: rotate;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    border-radius: 50%;
  }
}
</style>
